import { dataLayerPush } from '@libs/analytics';

export const trackSelectStore = (storeId: string) => {
    dataLayerPush({
        event: 'select_store',
        store_id: storeId,
        link_text: 'select store',
    });
};

export const trackNoLocationsFound = () => {
    dataLayerPush({
        event: 'error',
        site_section: 'select store',
        error_message: 'no locations found',
    });
};
